/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {

        //remove reading time smaller sign
        var $readTime = $('.rt-reading-time .rt-time');
        $readTime.each(function (index) {
          var readTimeText = $(this).html();
          $(this).html(readTimeText.replace(/\D+/g, ''));
        });

        //blog arrow color
        $(".blog-post-container").mouseover(function () {
          $(".blog-arrow", this).css("fill", "#ff7500");


        });
        $(".blog-post-container").mouseleave(function () {
          $(".blog-arrow", this).css("fill", "#aab3bf");


        });

        //navigation
        $(".hamburger").on('click', function () {  //// use a class, since your ID gets mangled
          $(this).toggleClass('is-active');
          $('body').toggleClass("hidden");
          $('.menu-holder').toggleClass("full-menu");
          $('.menu-holder .col-xl-9.col-md-8').toggleClass("display-nav");
        });
        $("#menu-primary-navigation li a").on('click', function () {
          $('body').removeClass("hidden");
          $('.menu-holder').removeClass("full-menu");
          $('.menu-holder .col-xl-9.col-md-8').removeClass("display-nav");
          $(".hamburger").removeClass('is-active');
        });
        $("#menu-primary-navigation-en li a").on('click', function () {
          $('body').removeClass("hidden");
          $('.menu-holder').removeClass("full-menu");
          $('.menu-holder .col-xl-9.col-md-8').removeClass("display-nav");
          $(".hamburger").removeClass('is-active');
        });

        var mobileNavQuery = window.matchMedia('screen and (min-width: 0px) and (max-width: 1023px)');
        var $navKontaktButton = $('.nav-menu .menu-btn-blue');
        $navKontaktButton.on('click', function() {
          if(mobileNavQuery.matches) {
            $('.hamburger.is-active').trigger('click');
          }
        });



        $(function () {
          // (Optional) Active an item if it has the class "is-active"
          $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();

          $(".accordion > .accordion-item").click(function () {
            // Cancel the siblings
            $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
            // Toggle the item
            $(this).toggleClass("is-active").children(".accordion-panel").slideToggle('ease-out');
          });
        });

        //Init WOW.js animations
        new WOW().init();

        //slider

        /* Header USPs slider swiper
        **************************************************************/
        var swiperHeaderUsp = Swiper;
        var headerUspInit = false;

        /* Which media query
        **************************************************************/
        var swiperHeaderUspsMode = function () {
          var mobile = window.matchMedia('screen and (min-width: 0px) and (max-width: 767px)');
          var tablet = window.matchMedia('screen and (min-width: 768px) and (max-width: 1023px)');
          var desktop = window.matchMedia('screen and (min-width: 1024px)');
          // Enable (for mobile)
          if (mobile.matches) {
            if (!headerUspInit) {
              headerUspInit = true;
              swiperHeaderUsp = new Swiper('.swiper-container-header', {
                slidesPerView: 1,
                autoplay: true,
                delay: 1000,
                loop: true,
              });
            }
          }
          // Disable (for tablet)
          else if (tablet.matches && headerUspInit) {
            $(swiperHeaderUsp).each(function () {
              this.destroy();
            });
            headerUspInit = false;
          }
          // Disable (for desktop)
          else if (desktop.matches && headerUspInit) {
            $(swiperHeaderUsp).each(function () {
              this.destroy();
            });
            headerUspInit = false;
          }
        };
        /* On Load
        **************************************************************/
        swiperHeaderUspsMode();
        /* On Resize
        **************************************************************/
        $(window).on('resize', function () {
          swiperHeaderUspsMode();
        });

        var swiper = new Swiper('.swiper-container-clwwd', {
          slidesPerView: 1,
          spaceBetween: 5,
          speed: 750,
          autoplay: true,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            }
          }
        });

        //dontworry slider
        var swiper2 = new Swiper('.swiper-container-worry', {
          slidesPerView: 4,
          spaceBetween: 38,
          speed: 750,
          navigation: {
            nextEl: '.swiper-button-next-worry',
            prevEl: '.swiper-button-prev-worry',
          },
          breakpoints: {
            // when window width is <= 1200px
            1200: {
              slidesPerView: 3,
              spaceBetween: 25,

            },
            769: {
              slidesPerView: 2,
              spaceBetween: 25,
            }
          }
        });
        //mobile experience slider
        var swiper3 = new Swiper('.swiper-container-me', {
          slidesPerView: 3,
          spaceBetween: 10,
          centeredSlides: true,
          loop: true,
          pagination: {
            el: '.swiper-pagination-me',
            type: 'bullets',
          },
          navigation: {
            nextEl: '.swiper-button-next-me',
            prevEl: '.swiper-button-prev-me',
          },
          1200: {
            slidesPerView: 1,
            spaceBetween: 10,

          },
        });



        /* Features Masonry swiper
        **************************************************************/
        var swiperFMasonry = Swiper;
        var fMasonryInit = false;

        /* Which media query
        **************************************************************/
        var swiperFMasonryMode = function () {
          var mobile = window.matchMedia('screen and (min-width: 0px) and (max-width: 767px)');
          var tablet = window.matchMedia('screen and (min-width: 768px) and (max-width: 1022px)');
          var desktop = window.matchMedia('screen and (min-width: 1024px)');
          // Enable (for mobile and tablet)
          if (mobile.matches || tablet.matches) {
            if (!fMasonryInit) {
              fMasonryInit = true;
              swiperFMasonry = new Swiper('.features-section-swiper', {
                //mobile settings
                slidesPerView: 1,
                spaceBetween: 15,

                //breakpoint settings
                breakpoints: {
                  768: {
                    slidesPerView: 2,
                  },
                },

                // general settings
                navigation: {
                  nextEl: '.swiper-button-next-masonry',
                  prevEl: '.swiper-button-prev-masonry',
                },
              });
            }
          }
          // Disable (for desktop)
          else if (desktop.matches && fMasonryInit) {
            $(swiperFMasonry).each(function () {
              this.destroy();
            });
            fMasonryInit = false;
          }
        };
        /* On Load
        **************************************************************/
        swiperFMasonryMode();
        /* On Resize
        **************************************************************/
        $(window).on('resize', function () {
          swiperFMasonryMode();
        });



        /* Problems swiper
        **************************************************************/
        var swiperProblems = Swiper;
        var problemsInit = false;

        /* Which media query
        **************************************************************/
        var swiperProblemsMode = function () {
          var mobile = window.matchMedia('screen and (min-width: 0px) and (max-width: 767px)');
          var tablet = window.matchMedia('screen and (min-width: 768px) and (max-width: 1022px)');
          var desktop = window.matchMedia('screen and (min-width: 1024px)');
          // Enable (for mobile and tablet)
          if (mobile.matches || tablet.matches) {
            if (!problemsInit) {
              problemsInit = true;
              swiperProblems = new Swiper('.swiper-container-facts', {
                //mobile settings
                slidesPerView: 1,
                spaceBetween: 15,

                //breakpoint settings
                breakpoints: {
                  768: {
                    slidesPerView: 2,
                  },
                },

                // general settings
                navigation: {
                  nextEl: '.swiper-button-next-facts',
                  prevEl: '.swiper-button-prev-facts',
                },
              });
            }
          }
          // Disable (for desktop)
          else if (desktop.matches && problemsInit) {
            $(swiperProblems).each(function () {
              this.destroy();
            });
            problemsInit = false;
          }
        };
        /* On Load
        **************************************************************/
        swiperProblemsMode();
        /* On Resize
        **************************************************************/
        $(window).on('resize', function () {
          swiperProblemsMode();
        });

        /* Overview swiper
        **************************************************************/
        var swiperOverview = Swiper;
        var overviewInit = false;

        /* Which media query
        **************************************************************/
        var swiperOverviewMode = function () {
          var mobile = window.matchMedia('screen and (min-width: 0px) and (max-width: 767px)');
          var tablet = window.matchMedia('screen and (min-width: 768px) and (max-width: 1023px)');
          var desktop = window.matchMedia('screen and (min-width: 1024px)');
          // Enable (for mobile)
          if (mobile.matches) {
            if (!overviewInit) {
              overviewInit = true;
              swiperOverview = new Swiper('.swiper-container-overview', {
                //mobile settings
                slidesPerView: 'auto',
                spaceBetween: 15,
                centeredSlides: true,

                //breakpoint settings
                breakpoints: {
                  768: {
                    slidesPerView: 2,
                    centeredSlides: false,
                  },
                },

                // general settings
                navigation: {
                  nextEl: '.swiper-button-next-overview',
                  prevEl: '.swiper-button-prev-overview',
                },
                on: {
                  init: function() {
                    this.snapGrid = this.slidesGrid.slice(0);//this init...
                  }
                }
              });
            }
          } else if (tablet.matches) {
            if (!overviewInit) {
              overviewInit = true;
              swiperOverview = new Swiper('.swiper-container-overview', {
                //mobile settings
                slidesPerView: '4',
                spaceBetween: 10,

                //breakpoint settings
                breakpoints: {
                  768: {
                    slidesPerView: 3,

                  },
                },

                // general settings
                navigation: {
                  nextEl: '.swiper-button-next-overview',
                  prevEl: '.swiper-button-prev-overview',
                },
              });
            }
          }
          // Disable (for desktop)
          else if ((desktop.matches) && overviewInit) {
            $(swiperOverview).each(function () {
              this.destroy();
            });
            overviewInit = false;
          }
        };




        /* On Load
        **************************************************************/
        swiperOverviewMode();
        /* On Resize
        **************************************************************/
        $(window).on('resize', function () {
          swiperOverviewMode();
        });

        /* Benefits swiper
        **************************************************************/
        var swiperBenefits = Swiper;
        var benefitsInit = false;

        /* Which media query
        **************************************************************/
        var swiperBenefitsMode = function () {
          var mobile = window.matchMedia('screen and (min-width: 0px) and (max-width: 767px)');
          var tablet = window.matchMedia('screen and (min-width: 768px) and (max-width: 1023px)');
          var desktop = window.matchMedia('screen and (min-width: 1024px)');
          // Enable (for mobile)
          if (mobile.matches) {
            if (!benefitsInit) {
              benefitsInit = true;
              swiperBenefits = new Swiper('.swiper-container-benefits', {
                slidesPerView: 1,
                spaceBetween: 22,

                // general settings
                navigation: {
                  nextEl: '.swiper-button-next-benefits',
                  prevEl: '.swiper-button-prev-benefits',
                },
              });
            }
          }
          // Disable (for tablet)
          else if (tablet.matches && benefitsInit) {
            $(swiperBenefits).each(function () {
              this.destroy();
            });
            benefitsInit = false;
          }
          // Disable (for desktop)
          else if (desktop.matches && benefitsInit) {
            $(swiperBenefits).each(function () {
              this.destroy();
            });
            benefitsInit = false;
          }
        };
        /* On Load
        **************************************************************/
        swiperBenefitsMode();
        /* On Resize
        **************************************************************/
        $(window).on('resize', function () {
          swiperBenefitsMode();
        });


        /* Blog swiper
        **************************************************************/
        var swiperBlog = Swiper;
        var blogInit = false;

        /* Which media query
        **************************************************************/
        var swiperBlogMode = function () {
          var mobile = window.matchMedia('screen and (min-width: 0px) and (max-width: 767px)');
          var tablet = window.matchMedia('screen and (min-width: 768px) and (max-width: 1023px)');
          var desktop = window.matchMedia('screen and (min-width: 1024px)');
          // Enable (for mobile)
          if (mobile.matches) {
            if (!blogInit) {
              blogInit = true;
              swiperBlog = new Swiper('.swiper-container-blog', {
                slidesPerView: 'auto',
                spaceBetween: 15,
                centeredSlides: true,
                on: {
                  init: function() {
                    this.snapGrid = this.slidesGrid.slice(0);
                  }
                }
              });
            }
          }
          // Disable (for tablet)
          else if (tablet.matches && blogInit) {
            $(swiperBlog).each(function () {
              this.destroy();
            });
            blogInit = false;
          }
          // Disable (for desktop)
          else if (desktop.matches && blogInit) {
            $(swiperBlog).each(function () {
              this.destroy();
            });
            blogInit = false;
          }
        };

        $("#menu-primary-navigation li a").each(function() {
          if ((window.location.pathname.indexOf($(this).attr('href'))) > -1) {
            $(this).addClass('activeMenuItem');
          }
        });

        /* On Load
        **************************************************************/
        swiperBlogMode();
        /* On Resize
        **************************************************************/
        $(window).on('resize', function () {
          swiperBlogMode();
        });

        /* Autofocus Contact form first input after it gets fully visible in viewport */
        $.fn.isInViewport = function () {
          var elementTop = $(this).offset().top;
          var elementBottom = elementTop + $(this).outerHeight();

          var viewportTop = $(window).scrollTop();
          var viewportBottom = viewportTop + $(window).height();

          return (elementBottom > viewportTop && elementBottom < viewportBottom) && (elementTop < viewportBottom && elementTop > viewportTop);
        };

        //set focus to first input field in form
        var $firstContactInput = $('.template-section-request #firstname');
        var matchInputFocusQuery = window.matchMedia('screen and (min-width: 1024px)');

        function checkInputViewport() {
          if(matchInputFocusQuery.matches){
            if($firstContactInput.isInViewport()) {
              $firstContactInput.focus();
            }
          }
        }

        $(window).on('scroll', function() {
          checkInputViewport();
        });
        checkInputViewport();


        //back to top button
        // Back to top
        var amountScrolled = 200;
        var amountScrolledNav = 25;

        $(window).scroll(function() {
          if ( $(window).scrollTop() > amountScrolled ) {
            $('button.back-to-top').addClass('show');
          } else {
            $('button.back-to-top').removeClass('show');
          }
        });

        $('button.back-to-top').click(function() {
          $('html, body').animate({
            scrollTop: 0
          }, 600);
          return false;
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired


      }
    },
    // Home page
    'home': {
      init: function () {


      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // blog pages
    'single_post': {
      init: function () {
        var $blogAnchorLinks = $('.entry-content ul li a').filter(function() {
          return $(this).attr('href').match(/^#(.*)/);
        });

        $blogAnchorLinks.each(function(index, value) {
          $(value).on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var targetID = $(this).attr('href');

            $([document.documentElement, document.body]).animate({
              scrollTop: $(targetID).offset().top - $('.menu-holder').outerHeight() - 20 /* minus header minus some offset */
            }, 600);
          });
        });

        function scrollProgress() {
          var winScroll = document.body.scrollTop || document.documentElement.scrollTop,
              height = document.documentElement.scrollHeight - document.documentElement.clientHeight,
              scrolled = (winScroll / height) * 100;
          document.getElementById("myBar").style.width = scrolled + "%";
        }

        window.onscroll = function() {scrollProgress();};      }
    },
    // About us page, note the change from about-us to about_us.
    'section-overview': {
      init: function () {

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


})(jQuery); // Fully reference jQuery after this point.
